import { HttpService } from './http';

export class NotificationService {
    static async getNotifications() {
        const service = new HttpService();
        return await service.get('/base/notification/', null);
    }

    static async getNotification(id) {
        const service = new HttpService();
        return await service.get(`/base/notification/${id}/`, null);
    }

    static async markAsRead(notificationId = null) {
        const service = new HttpService();
        const payload = notificationId ? { notification: notificationId } : {};
        return await service.post('/base/notification/read/', payload);
    }

    static async getUnreadCount() {
        const service = new HttpService();
        const notifications = await service.get('/base/notification/', null);
        const notificationsList = notifications?.results || notifications || [];
        return notificationsList.filter(n => !n.is_read).length;
    }
}

